import type { CardInstanceId, RunState } from "../types/index.js";

export function toggleHandDisruption(run: RunState, id: CardInstanceId): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "handDisruption" || !run.hand.some((card) => card.instanceId === id)) return null;
  if (pending.selected.length >= pending.count && !pending.selected.includes(id)) return null;
  const selected = pending.selected.includes(id)
    ? pending.selected.filter((item) => item !== id)
    : [...pending.selected, id];
  return { ...run, pendingChoice: { ...pending, selected } };
}

export function resolveHandDisruption(run: RunState): RunState | null {
  const pending = run.pendingChoice;
  if (pending?.kind !== "handDisruption") return { ...run, pendingChoice: null };
  if (pending.selected.length !== pending.count) return null;
  const discarded = run.hand.filter((card) => pending.selected.includes(card.instanceId));
  return {
    ...run,
    hand: run.hand.filter((card) => !pending.selected.includes(card.instanceId)),
    discard: [...run.discard, ...discarded],
    pendingChoice: null,
  };
}
